import { render, staticRenderFns } from "./DashboardInsurerMessages.vue?vue&type=template&id=99929d82&scoped=true"
import script from "./DashboardInsurerMessages.vue?vue&type=script&lang=js"
export * from "./DashboardInsurerMessages.vue?vue&type=script&lang=js"
import style0 from "./DashboardInsurerMessages.vue?vue&type=style&index=0&id=99929d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99929d82",
  null
  
)

export default component.exports